import { render, staticRenderFns } from "./CompareRow.vue?vue&type=template&id=fc01f606"
import script from "./CompareRow.vue?vue&type=script&lang=js"
export * from "./CompareRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports